import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inactive-side-nav',
  templateUrl: './inactive-side-nav.component.html',
  styleUrls: ['./inactive-side-nav.component.css']
})
export class InactiveSideNavComponent implements OnInit {

  constructor( public authService:AuthService) { }
  events: string[] = [];
  opened: boolean;

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);

  imageServerPath: string = "../../../assets/images/final automated.png";
  ngOnInit(): void {
    var logo = this.authService.getRegistredUserDetails();
    if (logo) {
      this.imageServerPath = logo['logoFile'];
    }
  }

  onImgError(event) {
    var reset = event.target.src = "../../../assets/images/final automated.png";
    //  var userData = this.authService.getRegistredUserDetails();
    //    userData.logoFile = reset;
    //    this.authService.setRegistredUserDetails(userData);
    //    //this.reloadComponent(true)
  }
  panelOpenState: boolean = false;


  public createImgPath = (serverPath: string) => {
    if (serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/final automated.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

}
